import { StatDisplay } from '@wajeez-web/components/ui';

export interface StatsGridProps {
  data: {
    label: string;
    value: number | string;
    loading: boolean;
    icon: JSX.Element;
  }[];
}

const StatsGrid = ({ data }: StatsGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {data.map((stat) => (
        <StatDisplay
          key={stat.label}
          label={stat.label}
          value={stat.value}
          loading={stat.loading}
          icon={stat.icon}
        />
      ))}
    </div>
  );
};

export default StatsGrid;
